<template>
  <Main :purchaseFabricCode="purchaseFabricCode" />
</template>

<script>
import Main from './main'

export default {
  name: 'DetailTableIndex',
  components: {
    Main,
  },
  props: {
    purchaseFabricCode: {
      type: String,
      default: '',
    },
  },
}
</script>
